<template>
  <div class="overflow-hidden max-h-full">
    <div
      class="flex justify-between p-4 items-center preview-modal-custom_header"
    >
      <h4 class="m-0 flex-1 text-center">
        Please Note
      </h4>

      <div>
        <button @click="$emit('close')">
          <i class="fal fa-times fa-lg" />
        </button>
      </div>
    </div>

    <div class="preview-modal-custom_body">
      <div class="mt-5 mx-5">
        <TrainingRecordExpiryNotes />
      </div>
      <hr />
      <div class="flex justify-center mb-5 mx-5">
        <button class="btn btn-info btn-fill" @click="$emit('close')">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TrainingRecordExpiryNotes from "./TrainingRecordExpiryNotes.vue";
export default {
  components: {
    TrainingRecordExpiryNotes
  },
  props: {},
  emits: ["close"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/paper/variables";
.preview-modal-custom {
  &_header {
    background-color: $light-gray;
  }
  &_body {
    max-height: 600px;
  }
  &_item {
    margin: auto 10px;
  }
}
</style>
